if (!customElements.get('nj-trust-scroller')) {
  customElements.define(
    'nj-trust-scroller',
    class NjTrustScroller extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.nj-trust__list');
        if (!this.list) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onResize = this.sync.bind(this);

        this.mobileQuery.addEventListener('change', this.onResize);
        window.addEventListener('resize', this.onResize);
        this.reduceMotion.addEventListener('change', this.onResize);

        this.sync();
      }

      disconnectedCallback() {
        this.stop();
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.onResize);
        window.removeEventListener('resize', this.onResize);
        if (this.reduceMotion) this.reduceMotion.removeEventListener('change', this.onResize);
      }

      sync() {
        this.stop();

        if (!this.mobileQuery.matches || this.reduceMotion.matches) return;

        const originals = Array.from(this.list.querySelectorAll('.nj-trust__item:not([data-clone])'));
        if (originals.length < 2) return;

        // Duplicate the row so translateX(-50%) loops seamlessly.
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.dataset.clone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          this.list.appendChild(clone);
        });

        const halfWidth = this.list.scrollWidth / 2;
        if (halfWidth <= this.clientWidth + 4) {
          this.stop();
          return;
        }

        // ~40px/sec — readable continuous crawl.
        const duration = Math.max(12, halfWidth / 40);
        this.style.setProperty('--nj-trust-duration', `${duration}s`);
        this.classList.add('is-looping');
      }

      stop() {
        this.classList.remove('is-looping');
        this.style.removeProperty('--nj-trust-duration');
        this.list.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        this.list.style.transform = '';
      }
    },
  );
}
